/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Reset_Password_Invalid_TokenInputs */

const en_common_sign_reset_password_invalid_token = /** @type {(inputs: Common_Sign_Reset_Password_Invalid_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This reset link is invalid or has expired. Please request a new one.`)
};

const zh_common_sign_reset_password_invalid_token = /** @type {(inputs: Common_Sign_Reset_Password_Invalid_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置链接无效或已过期，请重新申请。`)
};

/**
* | output |
* | --- |
* | "This reset link is invalid or has expired. Please request a new one." |
*
* @param {Common_Sign_Reset_Password_Invalid_TokenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_reset_password_invalid_token = /** @type {((inputs?: Common_Sign_Reset_Password_Invalid_TokenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Reset_Password_Invalid_TokenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_reset_password_invalid_token(inputs)
	return zh_common_sign_reset_password_invalid_token(inputs)
});
export { common_sign_reset_password_invalid_token as "common.sign.reset_password_invalid_token" }